import InputProcessor from './InputProcessor';
export default InputProcessor;
